module.exports = __webpack_public_path__ + "img/footer-log.10b738ed.png";